import * as z from "@-/com.npmjs.zod";
import { cardPinyinListEntrySliceSchema } from "#morpheme-pinyin-list-entry-slice-schema";
import { morphemeTierSchema } from "#morpheme-tier";

export const morphemeDetailsTileSliceGraphemeMorphemeSliceSchema = z.object({
  back: z.string().optional(),
  biau1Rank: z.int().min(1).nullish(),
  completed: z.boolean().optional(),
  description: z.string().nullish(),
  front: z.string(),
  hsk2010Level: z.int().nullish(),
  hsk2021Level: z.int().nullish(),
  hsk2026Level: z.int().nullish(),
  id: z.int().optional(),
  label: z.string().nullish(),
  /** Authored component mnemonics (meaning-card aliases), the gloss first when it is one. */
  mnemonicTerms: z.array(z.string()).optional(),
  morphemeType: z.literal("grapheme"),
  obsolete: z.boolean().optional(),
  pinyinList: z.array(cardPinyinListEntrySliceSchema),
  subtlexChrRank: z.int().min(1).nullish(),
  taiwanUsageClassification: z
    .enum(["common", "less-than-common", "rarely-used"])
    .nullable()
    .optional(),
  tbclLevel: z.int().nullish(),
  tier: morphemeTierSchema,
});

export const morphemeDetailsTileSliceWordMorphemeSliceSchema = z.object({
  back: z.string().optional(),
  biau2Rank: z.int().min(1).nullish(),
  completed: z.boolean().optional(),
  description: z.string().nullish(),
  front: z.string(),
  hsk2010Level: z.int().nullish(),
  hsk2021Level: z.int().nullish(),
  hsk2026Level: z.int().nullish(),
  id: z.int().optional(),
  morphemeType: z.literal("word"),
  pinyinList: z.array(cardPinyinListEntrySliceSchema),
  subtlexWfRank: z.int().min(1).nullish(),
  tier: morphemeTierSchema,
});

/** Minimum data to render a morpheme as a details button tile in a grid (deck, search results, levels, collections). */
export const morphemeDetailsTileSliceSchema = z.union([
  morphemeDetailsTileSliceGraphemeMorphemeSliceSchema,
  morphemeDetailsTileSliceWordMorphemeSliceSchema,
]);

export type MorphemeDetailsTileSliceGraphemeMorphemeSlice = z.infer<
  typeof morphemeDetailsTileSliceGraphemeMorphemeSliceSchema
>;
export type MorphemeDetailsTileSliceWordMorphemeSlice = z.infer<
  typeof morphemeDetailsTileSliceWordMorphemeSliceSchema
>;
export type MorphemeDetailsTileSlice = z.infer<typeof morphemeDetailsTileSliceSchema>;
